export const THUMBNAIL_IMAGE_DEFAULT = 'assets/bi/images/img_board_default2.png';
